module.exports = __webpack_public_path__ + "img/Cancel-date.c2a046e5.svg";